/*
CXS (Conlang X-SAMPA)
https://en.wikibooks.org/wiki/Conlang/Appendix/CXS#Comparison_between_CXS_and_IPA
with some fixups when they got their IPA wrong
*/

import { SegmentStrategy } from "../rules/intoSegments";
import { Rule } from "../rules/rule";
import { RuleSet } from "../rules/ruleSet";

/** convert CXS (Conlang X-SAMPA) to IPA */
export const cxsToIpa: RuleSet = {
  inputSegments: SegmentStrategy.Single,
  outputSegments: SegmentStrategy.Ipa,

  sortRulesByInputLength: true,
  rules: [
    { from: ")", to: '\u0361', post: 'swapWithPrev' },  // swap tie-bar w/ previous character

    { from: 'm', to: 'm' },
    { from: 'F', to: 'ɱ' },
    { from: 'n', to: 'n' },
    { from: "n`", to: 'ɳ' },
    { from: 'J', to: 'ɲ' },
    { from: 'N', to: 'ŋ' },
    { from: "N\\", to: 'ɴ' },
    { from: 'p', to: 'p' },
    { from: 'b', to: 'b' },
    { from: 't', to: 't' },
    { from: 'd', to: 'd' },
    { from: "t`", to: 'ʈ' },
    { from: "d`", to: 'ɖ' },
    { from: 'c', to: 'c' },
    { from: "J\\", to: 'ɟ' },
    { from: 'k', to: 'k' },
    { from: 'g', to: 'ɡ' },
    { from: 'q', to: 'q' },
    { from: "G\\", to: 'ɢ' },
    { from: ">\\", to: 'ʡ' },
    { from: "?", to: 'ʔ' },
    { from: "p\\", to: 'ɸ' },
    { from: 'B', to: 'β' },
    { from: 'f', to: 'f' },
    { from: 'v', to: 'v' },
    { from: 'T', to: 'θ' },
    { from: 'D', to: 'ð' },
    { from: 's', to: 's' },
    { from: 'z', to: 'z' },
    { from: 'S', to: 'ʃ' },
    { from: 'Z', to: 'ʒ' },
    { from: "s`", to: 'ʂ' },
    { from: "z`", to: 'ʐ' },
    { from: 'C', to: 'ç' },
    { from: "j\\", to: 'ʝ' },
    { from: 'x', to: 'x' },
    { from: 'G', to: 'ɣ' },
    { from: 'X', to: 'χ' },
    { from: 'R', to: 'ʁ' },
    { from: "X\\", to: 'ħ' },
    { from: "?\\", to: 'ʕ' },
    { from: "H\\", to: 'ʜ' },
    { from: "<\\", to: 'ʢ' },
    { from: 'h', to: 'h' },
    { from: "h\\", to: 'ɦ' },
    { from: 'P', to: 'ʋ' },
    { from: "r\\", to: 'ɹ' },
    { from: "r\\`", to: 'ɻ' },
    { from: 'j', to: 'j' },
    { from: "M\\", to: 'ɰ' },
    { from: "B\\", to: 'ʙ' },
    { from: 'r', to: 'r' },
    { from: "R\\", to: 'ʀ' },
    { from: ">\\:", to: 'ᴙ' },
    { from: '4', to: 'ɾ' },
    { from: "r`", to: 'ɽ' },
    { from: 'K', to: 'ɬ' },
    { from: "K\\", to: 'ɮ' },
    { from: "K`", to: 'ɬ̢' },
    { from: 'l', to: 'l' },
    { from: "l`", to: 'ɭ' },
    { from: 'L', to: 'ʎ' },
    { from: "L\\", to: 'ʟ' },
    { from: "l\\", to: 'ɺ' },
    { from: "l\\`", to: 'ɺ̢' },
    { from: '5', to: 'ɫ' },
    { from: 'W', to: 'ʍ' },
    { from: 'w', to: 'w' },
    { from: 'H', to: 'ɥ' },
    { from: "s\\", to: 'ɕ' },
    { from: "z\\", to: 'ʑ' },
    { from: "x\\", to: 'ɧ' },
    { from: "O\\", to: 'ʘ' },
    { from: "|\\", to: 'ǀ' },
    { from: "!\\", to: 'ǃ' },
    { from: "=\\", to: 'ǂ' },
    { from: "|\\|\\", to: 'ǁ' },
    { from: "b_<", to: 'ɓ' },
    { from: "d_<", to: 'ɗ' },
    { from: "J\\_<", to: 'ʄ' },
    { from: "g_<", to: 'ɠ' },
    { from: "G\\_<", to: 'ʛ' },

    // vowels
    { from: "@`", to: 'ɚ' },  // ə˞
    { from: "3`", to: 'ɝ' },  // ɜ˞ 
    { from: 'i', to: 'i' },
    { from: 'y', to: 'y' },
    { from: "i\\", to: 'ɨ' },
    { from: "1", to: 'ɨ' }, // alternative
    { from: "u\\", to: 'ʉ' },
    { from: "}", to: 'ʉ' }, // alternative
    { from: 'M', to: 'ɯ' },
    { from: 'u', to: 'u' },
    { from: 'I', to: 'ɪ' },
    { from: 'Y', to: 'ʏ' },
    { from: "I\\", to: 'ɪ̈' },
    { from: "U\\", to: 'ʊ̈' },
    { from: 'U', to: 'ʊ' },
    { from: 'e', to: 'e' },
    { from: '2', to: 'ø' },
    { from: "@\\", to: 'ɘ' },
    { from: '8', to: 'ɵ' },
    { from: '7', to: 'ɤ' },
    { from: 'o', to: 'o' },
    { from: "@", to: 'ə' },
    { from: 'E', to: 'ɛ' },
    { from: '9', to: 'œ' },
    { from: '3', to: 'ɜ' },
    { from: "3\\", to: 'ɞ' },
    { from: 'V', to: 'ʌ' },
    { from: 'O', to: 'ɔ' },
    { from: "&", to: 'æ' },
    { from: "{", to: 'æ' }, // alternative
    { from: '6', to: 'ɐ' },
    { from: 'a', to: 'a' },
    { from: "&\\", to: 'ɶ' },
    { from: 'A', to: 'ɑ' },
    { from: 'Q', to: 'ɒ' },

    // diacritics
    { from: "=", to: '̩' },
    { from: "_0", to: '̥' },
    { from: "_a", to: '̺' },
    { from: "_A", to: '̘' },
    { from: "_c", to: '̜' },
    { from: "_d", to: '̪' },
    { from: "_e", to: '̴' },
    { from: "_h", to: 'ʰ' },
    { from: "_G", to: 'ˠ' },
    { from: ";", to: 'ʲ' },
    { from: "_j", to: 'ʲ' },  // alternative
    { from: "_k", to: '̰' },
    { from: "_l", to: 'ˡ' },
    { from: "_m", to: '̻' },
    { from: "_n", to: 'ⁿ' },
    { from: "_N", to: '̼' },
    { from: "_o", to: '̞' },
    { from: "_O", to: '̹' },
    { from: "_q", to: '̙' },
    { from: "_r", to: '̝' },
    { from: "_t", to: '̤' },
    { from: "_v", to: '\u032C' },
    { from: "_x", to: '̽' },
    { from: "_X", to: '\u0306' },
    { from: "_w", to: 'ʷ' },
    { from: "_?\\", to: 'ˤ' },
    { from: "_>", to: 'ʼ' },
    { from: "_^", to: '̯' },
    { from: "_}", to: '̚' },
    { from: "_+", to: '̟' },
    { from: "_-", to: '̠' },
    { from: "_\"", to: '̈' },
    { from: "~", to: '̃' },
    { from: "`", to: '\u02DE', previous: ['vowel'] },  // vowels: rhotacized
    { from: "`", to: '\u0322', previous: ['consonant'] },  // consonant: retroflex
    { from: "'", to: 'ˈ' },
    { from: '"', to: 'ˈ' }, // alternative
    { from: ",", to: 'ˌ' },
    { from: "%", to: 'ˌ' }, // alternative
    { from: ":", to: 'ː' },
    { from: ":\\", to: 'ˑ' },
    // { from: ".", to: '.' },
    { from: "-\\", to: '‿' },  // linking
    { from: "|", to: '|' },
    { from: "||", to: '‖' },
    { from: "<R>", to: '↗' },
    { from: "<F>", to: '↘' },
    { from: "_T", to: '˥' },
    { from: "_H", to: '˦' },
    { from: "_M", to: '˧' },
    { from: "_L", to: '˨' },
    { from: "_B", to: '˩' },
    { from: "^", to: '↑' },
    { from: "_R", to: '\u030c' },
    { from: "_F", to: '̂' },
    { from: "!", to: '↓' },
  ],
}

export function getIpaToCxs(): RuleSet {
  if (!ipaToCxs) {
    ipaToCxs = {
      inputSegments: SegmentStrategy.Single,
      outputSegments: SegmentStrategy.Single,
      rules: reverseRules(cxsToIpa.rules as Rule[]),
    };
  }
  return ipaToCxs;
}
let ipaToCxs: RuleSet | undefined;

// simple reversal because there's no context
function reverseRules(rules: Rule[]): Rule[] {
  const noEmpty = rules.filter(r => r.to !== '');
  return noEmpty.map(rule => {
    return { from: rule.to, to: rule.from };
  });
}
